import { useState } from "react";
import BaseTabs from "../../components/common/base-tabs/base-tabs";
import BaseTitle from "../../components/common/base-title/base-title";
import { Container, Grid, List, ListItem } from "@mui/material";
import { useTranslation } from "react-i18next";
import { ContactForm } from "../../components/view/study-abroad/contact-form";
import { ContactAtripa } from "../../components/view/study-abroad/contact-atripa";
import { TabsContent } from "../../components/view/study-abroad/tab-content";

export default function WorkImmigration() {
    const { t } = useTranslation();
    //handle tab change
    const [activeTab, setActiveTab] = useState({
        germany: true,
    });

    const handleTabChange = type => {
        setActiveTab({ [type]: true });
    };

    const worklist = [
        {
            type: "germany",
            title: "اوسبیلدونگ آلمان",
            activeTab: activeTab?.germany,
            icon: "GermanyFlag",
            inactive: "AirplanInactiveIcon",
            content: {
                items: [
                    "اوسبیلدونگ یک مسیر آموزشی - شغلی  کابردی در آلمان است که به شما این امکان را میدهد تا همزمان با یادگیری یک تخصص به صورت آکادمیک ، وارد بازار کار شوید.",
                    "به دلیل شرایط پذیرش آسان در این دوره، اوسبیلدونگ آلمان یکی از مسیر های مهاجرت محبوب بین ایرانیان است.",
                    "در طول دوره همراه با آموزش تئوری و عملی، حقوق ماهیانه به شما پرداخت خواهد شد و علاوه بر معافیت از مالیات ، مشمول دریافت بیمه درمانی و بازنشستگی نیز خواهید بود.البته حقوق پرداختی به مخاطب کاملا برای تامین هزینه های زندگی در آلمان کافی خواهد بود.",
                    "رشته های متنوعی برای ثبت درخواست از ایران وجود دارند که بنا بر سلیقه مخاطب و رزومه مرتبط و ظرفیت های موجود ، با کمک مشاوره کارشناسان ما در آتریپا انتخاب خواهد شد و کل پروسه توسط تیم ما سپری خواهد شد تا در نهایت ویزا اوسبیلدونگ برای شما صادر شود.",
                ],
            },
        },
    ];

    return (
        <Container maxWidth="xl">
            <BaseTitle title={t("General.Work Immigration")} />
            <Grid container columnGap={2} alignItems="flex-start" mt={{ xs: 0, md: 5 }}>
                <Grid container item md={7.5} rowGap={6} mb={5}>
                    <Grid container rowGap={2}>
                        <BaseTabs list={worklist} handleTabChange={handleTabChange} />
                        {worklist.map(item => !!item.type === activeTab[item.type] && <TabsContent data={item?.content} />)}
                    </Grid>

                    <Grid container rowGap={2}>
                        <BaseTitle title="چرا اوسبیلدونگ آلمان" />
                        <List sx={{ color: "var(--dark-gray)" }}>
                            <ListItem sx={listStyle}>✓ دریافت حقوق ماهیانه در طول دوره و شانس بالای استخدام پس از پایان دوره</ListItem>
                            <ListItem sx={listStyle}>✓ مناسب افراد با حداقل تحصیلات در ایران(دیپلم) و شانس بالای استخدام پس از پایان دوره</ListItem>
                            <ListItem sx={listStyle}>
                                ✓ آموزش کاربردی تئوری و عملی و اعطا مدرک معتبر در سراسر اتحادیه اروپا به مخاطب در پایان دوره
                            </ListItem>
                            <ListItem sx={listStyle}>✓ امکان استخدام در خارج از آلمان و دریافت جاب آفر در سراسر اتحادیه اروپا</ListItem>
                            <ListItem sx={listStyle}>✓ مسیر کاملا مشخص بدون پیش شرط های پیچیده و بسیار کوتاه جهت مهاجرت به آلمان</ListItem>
                        </List>
                    </Grid>
                    <ContactAtripa />
                </Grid>
                <ContactForm endPoint="/visa/job/contact-request/" />
            </Grid>
        </Container>
    );
}

export const listStyle = { fontSize: { xs: "0.875rem", md: "1rem" }, textAlign: "justify", padding: { xs: "4px", md: "8px" } };
